import { gql } from '@apollo/client';

export const CONVERSATION = gql`
  query conversation($event_request_id: String!, $supplier_id: String!) {
    conversations(
      where: {
        event_request_id: { equals: $event_request_id }
        supplier_id: { equals: $supplier_id }
      }
    ) {
      uuid
    }
  }
`;
